import { OriginSize } from "shared/origin";

export class DefaultConfig {
    public static blockSize: number = 70;
    public static rows: number = 7;
    public static columns: number = 7;
    public static mapWidth: number = OriginSize.width * 0.7;
    public static mapHeight: number = OriginSize.width * 0.7;
    public static colors: string[] = ['red', 'green', 'blue', 'brown', 'yellow']
}